"use strict";

module.exports.getTopRelativeToDocument = function(element) {
  var elementBoundaries = element.getBoundingClientRect();

  var body = document.body;
  var docElem = document.documentElement;

  //Height relative to the scroll
  var scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
  var clientTop = docElem.clientTop || body.clientTop || 0;
  //Top Position relative to the document
  return elementBoundaries.top + scrollTop - clientTop;
};

module.exports.getLeftRelativeToDocument = function(element) {
  var elementBoundaries = element.getBoundingClientRect();

  var body = document.body;
  var docElem = document.documentElement;

  //Height relative to the scroll
  var scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft;
  var clientLeft = docElem.clientLeft || body.clientLeft || 0;
  //Top Position relative to the document
  return elementBoundaries.left + scrollLeft - clientLeft;
};



// WEBPACK FOOTER //
// ./app/util/browser/client-rect.js